import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../api';
import { Button } from '@mui/material';

function ListaPreOrcamentos({ onSelecionar }) {
  const [orcamentos, setOrcamentos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregarOrcamentos = async () => {
      try {
        const res = await axios.get(`${API_URL}/preorcamento/listar`);
        setOrcamentos(res.data);
      } catch (err) {
        console.error('Erro ao carregar pré-orçamentos:', err);
        alert('Erro ao carregar a lista de pré-orçamentos');
      } finally {
        setLoading(false);
      }
    };

    carregarOrcamentos();
  }, []);

  const handleExcluir = async (id) => {

    
  if (window.confirm('Tem certeza que deseja excluir este pré-orçamento?')) {
    try {
      await axios.delete(`${API_URL}/preorcamento/${id}`);
      setOrcamentos(prev => prev.filter(o => o.id !== id));
      alert('Pré-orçamento excluído com sucesso.');
    } catch (err) {
      console.error('Erro ao excluir:', err);
      alert('Erro ao excluir pré-orçamento.');
    }
  }
};

const handleExcluirTodos = async () => {
  if (window.confirm('Tem certeza que deseja excluir TODOS os pré-orçamentos?')) {
    try {
      await axios.delete(`${API_URL}/preorcamento/`);
      setOrcamentos([]);
      alert('Todos os pré-orçamentos foram excluídos com sucesso.');
    } catch (err) {
      console.error('Erro ao excluir todos:', err);
      alert('Erro ao excluir todos os pré-orçamentos.');
    }
  }
};


  if (loading) return <p>Carregando...</p>;

  

  return (
    <div style={{ maxWidth: 900, margin: '20px auto', padding: 20 }}>
      <h2>Lista de Pré-Orçamentos Cadastrados</h2>


 {/*  
<Button
  variant="outlined"
  color="error"
  onClick={handleExcluirTodos}
  sx={{ fontWeight: 600, mb: 2, ml: 2 }}
>
  Excluir Todos
</Button>
*/}

          <Button
      variant="outlined"
      color="secondary"
      onClick={() => onSelecionar('voltar')}
      sx={{ fontWeight: 600, mb: 3 }}
    >
      Voltar para o GPD
    </Button>



<table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
  <thead>
    <tr>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Código Impram</th>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Cliente</th>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Código do Cliente</th>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Descrição do Item</th>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Demanda</th>
      <th style={{ border: '1px solid #ccc', padding: 8 }}>Data</th>
      <th style={{ border: '1px solid #ccc', padding: 8, width: 200 }}>Ações</th>


    </tr>
  </thead>
<tbody>
  {orcamentos.length === 0 ? (
    <tr>
      <td colSpan={7} style={{ textAlign: 'center', padding: 10, border: '1px solid #ccc' }}>
        Nenhum pré-orçamento encontrado.
      </td>
    </tr>
  ) : (
    orcamentos.map((orcamento) => (
      <tr key={orcamento.id}>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>{orcamento.im}</td>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>{orcamento.cliente}</td>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>
          {orcamento.itensProduto?.[0]?.codigo || '-'}
        </td>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>
          {orcamento.itensProduto?.[0]?.descricao || '-'}
        </td>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>
          {orcamento.itensProduto?.[0]?.demanda || '-'}
        </td>
        <td style={{ border: '1px solid #ccc', padding: 8 }}>
  {orcamento.dataInicio ? new Date(orcamento.dataInicio).toLocaleDateString('pt-BR') : '-'}
</td>

        <td style={{ border: '1px solid #ccc', padding: 8 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => onSelecionar(orcamento)}
          >
            Abrir
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleExcluir(orcamento.id)}
            style={{ marginLeft: 8 }}
          >
            Excluir
          </Button>
        </td>
      </tr>
    ))
  )}
</tbody>

</table>



    </div>
  );
}

export default ListaPreOrcamentos;
